import { defineStore } from "pinia";
import { ref } from "vue";
export var EstimateTabMain;
(function (EstimateTabMain) {
    EstimateTabMain[EstimateTabMain["\uC870\uD68C"] = 0] = "\uC870\uD68C";
    EstimateTabMain[EstimateTabMain["\uC791\uC131_\uC218\uC815"] = 1] = "\uC791\uC131_\uC218\uC815";
})(EstimateTabMain || (EstimateTabMain = {}));
/**
 * @description 페이지 관련 스토어
 *
 * @params tab_main - 조회/작성 탭 상태
 * @params tab_main_items - 조회/작성 탭 아이템
 * @params edit_buttons_show - 수정 버튼 보이기 상태
 * @params during_edit - 현재 편집 중인지 여부 (하나가 편집중이면 다른 탭은 편집 불가)
 *
 * @params dialog_calculate_labor - 노무비 계산 다이얼로그 보이기 상태
 * @params dialog_search_product - 제품 검색 다이얼로그 보이기 상태
 * @params dialog_payment - 결제 다이얼로그 보이기 상태
 */
export const useObtainPageStore = defineStore("obtainPage", () => {
    const tab_main = ref(EstimateTabMain.조회);
    const tab_main_items = ref(["조회", "작성/수정"]);
    return {
        tab_main,
        tab_main_items,
    };
});
